module.exports = __webpack_public_path__ + "img/it-reference-02.d3e889f4.jpg";